import {
  UPDATE_TENANT,
  UPDATE_TENANT_SUCCESS,
  UPDATE_TENANT_ERROR,
  UPDATE_TENANT_EDIT_STATE,
} from "../../actions";

export const updateTenant = (tenantToUpdate, id) => ({
  type: UPDATE_TENANT,
  payload: { tenantToUpdate, id }
});

export const updateTenantSuccess = (successMessage) => ({
  type: UPDATE_TENANT_SUCCESS,
  payload: { successMessage },
});

export const updateTenantError = (message) => ({
  type: UPDATE_TENANT_ERROR,
  payload: { message },
});

export const updateTenantEditState = (updatedValues) => ({
  type: UPDATE_TENANT_EDIT_STATE,
  payload: { updatedValues }
});